import * as React from 'react'
import { ReactElement } from 'react'
import { LegalAidCertificateDto } from './LegalAidCertificateForm'
import { Currency } from '../../../config/i18nConfig'
import { Input } from '@fluentui/react-components'
import { useFormikContext } from 'formik'
import { formatCurrencyDecimals, formatNumber, parseNumber } from '../../../helpers/numberHelper'
import PinnerInputField from './PinnerInputField'
import { LegalAidCertificatePanelProps } from './FormContainer'

type Props = Pick<LegalAidCertificatePanelProps, 'styles'> & {
    fieldName: keyof Pick<LegalAidCertificateDto, 'travelDistance'>
    pinnedFieldName: keyof Pick<LegalAidCertificateDto, 'travelExpenses'>
    rate: string
    currency: Currency
    disabled: boolean
}

export default function LegalAidTravelDistanceInput({
    styles,
    fieldName,
    pinnedFieldName,
    rate,
    currency,
    disabled,
}: Props): ReactElement {
    const {
        values: { [fieldName]: value },
        setFieldValue,
    } = useFormikContext<LegalAidCertificateDto>()
    const parsedValue = formatNumber(value, '0.', 'en')

    return (
        <PinnerInputField
            fieldName={fieldName}
            pinnedFieldName={pinnedFieldName}
            getPinnedValue={() => formatCurrencyDecimals(parseNumber(value, 'en') * parseNumber(rate, 'en'), currency)}
        >
            <Input
                disabled={disabled}
                value={parsedValue}
                placeholder="Afstand"
                className={styles.input}
                contentAfter="km"
                onChange={(_, data) => {
                    // Set a timeout to push the onChange() to the end of the event queue, so the onBlur() event in the
                    // pinned field will run first.
                    setTimeout(() => {
                        const value = data.value.replace(/\D/, '')
                        setFieldValue('travelDistance', value)
                    }, 0)
                }}
            />
        </PinnerInputField>
    )
}
